import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import Tab from '../../Tab';
import s from './UnderlinedTab.scss';
/** A single, standalone tab matching the look of UnderlinedTabs.
 * You should probably not use this */ const UnderlinedTab = (_param)=>{
    var { className, size } = _param, props = _object_without_properties(_param, [
        "className",
        "size"
    ]);
    return /*#__PURE__*/ React.createElement(Tab, _object_spread_props(_object_spread({}, props), {
        viewClassNames: {
            tab: classnames(s['tab'], size && s[size], className),
            label: s['label'],
            prefix: s['prefix'],
            dropdown: s['dropdown'],
            'active-tab': s['active-tab']
        }
    }));
};
UnderlinedTab.displayName = 'UnderlinedTab';
export default UnderlinedTab;

//# sourceMappingURL=UnderlinedTab.js.map